export default {
   'Search': 'Suche',
   'Users': 'Nutzer',
   'Email': 'E-Mail',
   'Phone Number': 'Telefonnummer',
   'Address': 'Adresse',
   'Company login': 'login',
    
 /****************** Navbar *************/
    'Logout': 'abmelden',
    'Profile': 'Profil',
    'Invoices':'Rechnungen',
 /****************** Dashboard Datatable ***********/
   'Title': 'Name',
   'Version': 'Version',
   'Module Slug': 'Modul',
   'Progress': 'Fortschritt',
   'Attempted on': 'am',
   'Score':'Punkte',
   'Your Quizes':'Quiz',
   'Launch':'Start',
   'Jump To Quiz': 'Zum Test springen',
   'Rows per page': 'Einträge per Seite',
 /****************** Users ***********/
    'Name': 'Name',
    'Actions': 'Aktionen',
    'Image' : 'Bild',
    'Salutation': 'Anrede',
    'Invite Users': 'Nutzer einladen',
     'Date of birth': 'Geburtsdatum',
     'All cards': 'alle Karten',
     'Card added successfully':'Karte erfolgreich hinzugefügt',
     'Remove' :'entfernen',
     'User Profile': 'Nutzer Profil',
     'All Cards': 'Alle Kurse',
     'Add Card' : 'Kurs hinzufügen',
     'Primary': 'Primäre Farbe',
     'Are you sure want to remove?': 'Wirklich entfernen?',
     'Subscribe' : 'teilnehmen',
     'Are you sure you want to purchase?':'Jetzt kaufen?',
     'Yes':'Ja',
     'No':'Nein',
     'You dont seem to have a card added to your profile':'Keine Zahlungsart hinterlegt',
     'Go to profile':'Kreditkarte hinterlegen',
 /****************** Courses ***********/
    'Filters':'Filter',
    'Details': 'zum Modul',
    'Purchased': 'gekauft',
    'Included' : 'inklusive',
    'What Will you Learn?': 'Lerninhalte',
    'Requirements' : 'Voraussetzungen',
    'Description' : 'Beschreibung',
    'PLAY NOW': 'jetzt starten',
    'Language': 'Sprache',
   'Close': 'Schließen',
   'Upload': 'Hochladen',
   'Submit': 'Absenden',
   'User csv file': 'Nutzer CSV Datei',
   'Module name here': 'Hier Kursnamen eintragen',
   'Subscription': 'Abo',
   'Languages': 'Sprachen',
   'Module': 'Modul',
   'Subject': 'Titel',
   'Body': 'Nachricht',
   'Send copy to myself' : 'Eine Kopie an mich senden',
   'Contact us': 'Nimm Kontakt auf',
   'Status': 'Status',
   'Join date': 'Beitrittsdatum',
   'Change status': 'Status ändern',
   'Active': 'aktiv',
   'active': 'aktiv',
   'Inactive':'inaktiv',
   'inactive':'inaktiv',
   'disable': 'deaktivieren',
   'pending': 'ausstehend',
   'Pending': 'ausstehend',
   'Place of birth': 'Geburtsort',
   'Subscribed':'eingeschrieben',
   'Unsubscribed':'nicht eingeschrieben',
   'English':'Englisch',
   'German':'Deutsch',
   'User updated successfully': 'Nutzer erfolgreich aktualisiert',
   'User created successfully': 'Nutzer erfolgreich erstellt',

   'Modules': 'Module',
   'Your Modules': 'Deine Module',

   'No modules found': 'Keine Module gefunden',
   'Course':'Kurse',
   'Your attempted modules': 'Deine Modul Versuche',
   'No data found': 'keine Daten gefunden',
   'Time Spent' : 'verbrachte Zeit',
   'From': 'vom',
   'To': 'bis zum',
   'Play':'abspielen',  
   'Your sessions': 'Deine Sessions',
   'Your attempts': 'Deine Versuche',    
   'Settings': 'Einstellungen',
   'View': 'ansehen',
   'Roles': 'Rollen',
   'Group': 'Gruppe',   
   'Comment (optional)': 'Kommentar (optional)',
   'Due date': 'gültig bis',
   'Select file': 'Dokument aussuchen',
   'Days until': 'Tage gültig',
   'Template' : 'Vorlage',
   'Update': 'Update',
   'Edit': 'Editieren', 
   'Uploaded by': 'hochgeladen von',  
   'Uploaded on': 'hochgeladen am',
   'Type':'Typ',
   'Action':'Aktion',
   'Stage 1': 'Bereich 1',
   'Stage 2': 'Bereich 2',
   'Set Name': 'Name',
   'Show next': 'zeige die nächsten x Tage',
   'Show from':'zeige die darauffolgenden nächsten x Tage',   
   'Name is required': 'Name wird benötigt',
   'Invalid Email address': 'Keine gültige E-Mail Adresse',
   'Phone Number is required': 'Es wird eine Telefonnummer benötigt',
   'Salutation is required':'Ansprache wird benötigt',
   'Address is required': 'Adresse wird benötigt',
   'Group admin is required':'Gruppen Admin muss erstellt werden',
   'Groups are required': 'Gruppen werden benötigt',
   'Status is required': 'Status wird benötigt',
   'Mr': 'Herr',
   'Mrs':'Frau',  
   'Set Filter':'Filter setzen',
   'Location':'Ort',
   'Procedure': 'Prozedur',
   'Class':'Klasse',
   'Maker':'Hersteller',
   'Serial maker': 'Hersteller',
   'Stock':'Lager',
   'Good until date': 'gültig bis',
   'Equipment':'Ausstattung',
   'Equipment created successfully':'Equipment erfolgreich angelegt',
   'Equipment updated successfully':'Equipment erfolgreich ge-updated',
   'Equipment Group':'Ausrüstungsgruppe',
   'Add Equipment Group': 'Ausrüstungsgruppe hinzufügen',
   'Edit Equipment Group': 'Ausrüstungsgruppe ändern',
   'Equipment group name': 'Ausrüstungsgruppenname',
   'Equipment group name is required': 'Ausrüstungsgruppenname is notwendig',
   'Equipment group added successfully': 'Ausrüstungsgruppe erfolgreich hinzugefügt',
   'Equipment group updated successfully': 'Ausrüstungsgruppe erfolgreich geändert',

   
   'Add Equipment Template': 'Kalibrationsvorlage hinzufügen',
   'Edit Equipment Template': 'Kalibrationsvorlage ändern',
   'Equipment template added successfully': 'Kalibrationsvorlage erfolgreich hinzugefügt',
   'Equipment template updated successfully':'Kalibrationsvorlage erfolgreich geändert',
   'Equipment name':'Name des Ausrüstungsgegenstandes',
   'Add Items':'Ausrüstungsgegenstand hinzufügen',
   'Edit Items':'Ausrüstungsgegenstand ändern',
   'Equipment image':'Bild des Ausrüstungsgegenstands',
   'Equipment templates':'Kalibrationsvorlagen',
   'Equipment template name':'Kalibrationsvorlagenname',  
   'Equipment group':'Ausrüstungsgruppe',
   'Equipment group is required': 'Ausrüstungsgruppe wird benötigt',
   'Equipment groups': 'Ausrüstungsgruppen',
   'Equipment template': 'Kalibrationsvorlage',
   'Equipment template id': 'Kalibrationsvorlagen ID' , 
   'Equipment Template':'Kalibrationsvorlage',
   'Items': 'Ausrüstungsgegenstände',
   'Number in stock': 'Lagerbestand',
   'Location is required':'Der Ort wird benötigt',
   'Class is required':'Klasse wird benötigt',
   'Maker is required':'Hersteller wird benötigt',
   'Number in stock is required':'Lagerbestand wird benötigt',
   'Goods until date is required':'Gültig bis wird benötigt',
   'Procedure is required':'Prozedur wird benötigt',
   'Description is required':'Beschreibung wird benötigt',
   'Group name': 'Gruppen-Name',
   'Group admins': 'Gruppen Administratoren',
   'Group name is required':'Gruppen-Name wird benötigt',
   'Users are required': 'Nutzer werden benötigt',
   'Course are required':'Kurse werden benötigt',
   'Company settings': 'Administration des Accounts',
   'Company Color': 'Firmen Primärfarbe',
   'Session login time': 'Login Zeit',
   'Primary color is required':'Farbe kann nicht leer sein',
   'Company settings updated successfully':'Firmeneinstellungen erfolgreich geändert',
   'Intellectual Property Rights':'Rechte an geistigen Eigentum',
   'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Sofern nicht anders angegeben, sind die Website und alle Quellcodes, Datenbanken, Funktionen, Software, Website-Designs, Audio-, Video-, Text-, Foto- und sonstigen Lernmaterialien auf der Website (zusammen der „Inhalt“) sowie die Marken, Dienstleistungsmarken, und darin enthaltene Logos (zusammen die „Marken“)  durch Urheber- und Markenrechte sowie verschiedene durch andere Rechte an geistigem Eigentum und an den Gesetzen gegen unlauteren Wettbewerb in Deutschland, ausländischen Gerichtsbarkeiten und internationalen Konventionen geschützt.',
   'I accept this (required)': 'Ich akzeptiere das (erforderlich)',
   'Please subscribe to a course': 'Bitte melden Sie sich zu einem Kurs an',
   'Your score': 'Erreichte Punkte',
   'Go to courses': 'Zu den Kursen',
   'Max Score' : 'Maximale Punkte',
   'Time taken':'Verbrachte Zeit',
   'Pass Score':'Benötigte Punkte',
   'No subscribed courses found':'Sie sind noch keinem Kurs beigetreten',   
   'Role is required':'Rolle wird benötigt',
   'Confirm Password is required':'Bitte bestätigen Sie das Passwort',
   'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',
   'Password must be at least 8 characters long': 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must be at least 8 characters long' : 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',   
   'Query successfully sent': 'Erfolgreich gesendet',
   'Dashboard': 'Dashboard',
   'Courses': 'Kurse',
   'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
   'Check':'filtern',
   'Clear': 'löschen',
   'Groups': 'Gruppen',
   'Inbox': 'Inbox',
   'No data available': 'Keine Einträge gefunden.',
   'Company color': 'Firmen Primärfarbe',
   'Learning material': 'Lernmaterial',
   'Search learning material': 'Lernmaterial durchsuchen',
   'Learning material updated successfully':'erfolgreich akutalisiert',
   'Learning material are required':'Lernmaterial wird benötigt',
   'Learning material name':'Lernmaterial Name',
   'Update Password': 'Passwort aktualisieren',
   'This password reset token is invalid': 'Bitte kontaktieren Sie ihren Admin, Ihr Link ist abgelaufen.',
   'Password is required':'Passwort ist notwendig',   
   'Accept & Continue': 'Akzeptieren und weiter',
   'Due days is required':'Due Date wird benötigt',
   'Learn NDT': 'Learn NDT',
   'Username':'Name',
   'Password':'Passwort',
   'Forgot password': 'Passwort vergessen',
   'Register':'Registrieren',
   'Login':'Login',   
   'Username is required': 'Name wird benötigt',
   'Phone is required':'Telefonnummer wird benötigt',
   'User registeration successfully': 'Nutzer erfolgreich registriert',
   'Company Admin Login': 'Login',
   'Go to Login': 'zum Login',
   'Send link':'Link senden',
   'No user documents':'keine Nutzer-Dokumente',
   'User documents':'Nutzer-Dokumente',
   'Update user documents' : 'Nutzer-Dokument aktualisieren',
   'Edit user documents': 'Nutzer-Dokumente editieren',
   'Module details': 'Modul Details',
   'passed':'bestanden',
   'Passed':'bestanden',
   'failed':'nicht bestanden',  
   'of':'aus',
   'Create user documents':'Nutzer Dokument erstellen',
   'Passwords must match': 'Wiederholen Sie aus Sicherheitsgründen das oben genannte Passwort.',
   'attempted': 'versucht',
   'Progress & Attempts': 'Fortschritt & Versuche',
   'Attempted': 'versucht',
   'Attempts': 'Versuche',
   'Save': 'speichern',
   'Details new': 'öffnen',
   'Profile updated successfully': 'Profil erfolgreich aktualisiert',
   'User document name': 'Name des Dokuments',
   'Group created successfully': 'Gruppe erfolgreich erstellt',
   'Group updated successfully': 'Gruppe erfolgreich aktualisiert',
   'User document updated successfully':'Nutzer Document erfolgreich aktualisiert',
   'Registration status changed successfully': 'Status erfolgreich aktualisiert',
   'Write to Company Representative': 'Ich habe eine Frage',
   'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here.':'Herzlich willkommen im Bereich Lernmaterial. Sobald Sie einen Kurs erfolgreich absolviert haben, können Sie die Lernmaterialien hier erneut nutzen.',
   'No Learning material found':'Es wurde kein Lernmaterial gefunden.',
   'OK':'OK',
   'Cancel': 'abbrechen',
   'Body is required':'Nachricht wird benötigt.',
   'Subject is required':'Titel wird benötigt',
   'Undefined':'Allgemein',
   'Copyright legal notice':'Copyright',
   'Please upload a file':'Bitte wählen Sie eine gültige Datei aus.',
   'The value must be an integer number':'Bitte tragen Sie eine Telefonnummer ein.',
   'Date is required': 'Datum wird benötigt',
   'Session minutes is required':'Minuten werden benötigt',
   '& others':'& weitere',
   'Continue':'WEITER',
   'All':'Alle',
   'Confirm Password': 'Passwort bestätigen',
   'Reset your Password':'Passwort zurücksetzen',
   'Group id':'Gruppen ID',
   'Check all': 'Alle auswählen',
   'Uncheck all' : 'Auswahl aufheben',
   'Not subscribed': 'Nicht eingeschrieben',
   'Reset': 'löschen',
   'dashboardstats': 'zeige {users} {userstat} und  {courses} {coursesstat} ',
   'Reminder': 'Erinnerungen',
   'Reminder email': 'Erinnerungs email',
   'Email timespan': 'E-Mail Zeitspanne',  
   "Email timespan is required" : "E-Mail Zeitspanne ist notwendig",
   'Reminder created successfully' : 'Erinnerung erfolgreich erstellt',
   'Reminder updated successfully' : 'Erinnerung erfolgreich aktualisiert',
   'Inventory number': 'Inventar Nummer',
   'Setup Items': 'Einrichtung',
   'Items Board':'Board',
   'Task Center':'Aufgaben Center',
   'Task Template': 'Aufgabenvorlagen',
   'Tasks':'Aufgaben',
   'Task Group':'Aufgabengruppe',
   'User Group':'Nutzergruppe',
   'All Groups': 'Alle Gruppen',
   'Personal Template': 'Personen Vorlage',

   'Template name': 'Vorlagenname',
   'Validity':'Zeitraum',
   'Select template': 'Vorlage auswählen',
   'Template name is required':'Vorlagenname is notwendig',
   'Validity is required':'Zeitraum wird benötigt',
   'Template file is required':'Vorlagendatei wird benötigt',

   'Operational status':'operationaler Status',
   'Operational status is required':'operationaler Status wird benötigt',
   'Not operational': 'nicht einsatzfähig',
   'Operational':'einsatzfähig',   
   'Serial number': 'Seriennummer',
   'Category': 'Kategorie',
   'Add category': 'Kategorie hinzufügen',  

   'Update document': 'Board',
   'Create document': 'Einrichtung',
   'Task template id': 'Aufgabenvorlagen ID',
   'Add Task Center template': 'Aufgabenvorlage hinzufügen',
   'Edit Task template':'Aufgabenvorlage ändern',
   'Task template name': 'Aufgabenvorlagename',
   'Task templates' : 'Aufgabenvorlagen',
   'Task id': 'Aufgaben ID',
   'Validity type is required': 'Verhalten wird benötigt',
   'Validity type': 'Verhalten',
   'Add Task template':'Aufgabenvorlage hinzufügen',
   'One time': 'Einmalig',
   'Recurring': 'Wiederholend',
   'Task template added successfully': 'Aufgabenvorlage erfolgreich hinzugefügt',
   'Task template updated successfully': 'Aufgabenvorlage erfolgreich geändert',
   'Add Task': 'Aufgabe hinzufügen',
   'Edit Task': 'Aufgabe editieren',
   'Task name':'Aufgabenname',  
   'Task template':'Aufgabenvorlage',
   'Edit Task document': 'Aufgaben Dokument ändern',
   'Update Task document':'Aufgaben Dokument aktualisieren',  
   'Task template are required': 'Aufgabenvorlage wird benötigt',
   'Task description is required': 'Aufgabenbeschreibung wird benötigt',
   'Task document updated successfully': 'Aufgabendokument erfolgreich geändert',
   'Task added successfully' : 'Aufgabe erfolgreich hinzugefügt',
   'Task updated successfully' : 'Aufgabe erfolgreich geändert',
   'Task name is required':'Aufgabenname wird benötigt',
   'Task group id': 'Aufgabengruppen ID',
   'Add Task Group': 'Aufgabengruppe hinzufügen',
   'Edit Task Group': 'Aufgabengruppe ändern',
   'Task group name': 'Aufgabengruppenname',
   'Task group name is required': 'Aufgabengruppenname wird benötigt',
   'Task group added successfully' : 'Aufgabengruppenname erfolgreich hinzugefügt',
   'Task group updated successfully' : 'Aufgabengruppen erfolgreich geändert',
   'Add Personal document':'Persönliches Dokument hinzufügen',
   'Edit Personal document': 'Persönliches Dokument ändern',
   'Personal template name' : 'Name der persönliche Vorlage',
   'Personal templates': 'persönliche Vorlagen',
   'Personal template name is required': 'persönliche Vorlage wird benötigt',
   'Personal template added successfully': 'persönliche Vorlage erfolgreich hinzugefügt',
   'Personal template updated successfully':'persönliche Vorlage erfolgreich geändert',
   'Task group':'Aufgabengruppe',   
   'Serial number is required':'Seriennummer wird benötigt',
   'Video': 'Video',
   'Remove out from Inbox':'Aus der Inbox entfernen',
   'Update Calibration document': 'Dokument erneuern',
   'Certifications': 'Zertifikate',
   'Course name':'Kurs',
   'Completed on':'bestanden am',
   'Report': 'Meldung',
   'Report Issue': 'Fehler melden',
   'Slide id is required': 'Slide ID wird benötigt',
   'Slide Id': 'Slide ID',
   'Message is required': 'Nachricht darf nicht leer sein',
   'Message': 'Nachricht',
   'Bug sent successfully': 'Meldung erfolgreich übermittelt',
   'Drafts': 'Entwürfe',
   'Title is required' : 'Titel wird benötigt',
   'Title must be less than 20 characters' : 'Der Titel muss weniger als 20 Zeichen betragen',
   'Font is required':'Schriftart wird benötigt',
   'Font size is required':'Schriftgröße wird benötigt',
   'Certificate is required':'Vorlagedatei wird benötigt',
   'Please drop fields on PDF':'Bitte setzten See die Felder auf die PDF',
   'Please select font size':'Bitte wählen Sie eine Schriftgröße',
   'Please select font':'Bitte wählen Sie eine Schriftart',
   'Preview':'Vorschau',
   "Font":'Schrift',
   "Font size":'Schriftgröße',
   'Add personal template': 'Vorlage hinzufügen',
   'Edit personal template': 'Vorlage bearbeiten',
   'Add task center template':'Task Center Vorlage hinzufügen',
   'Edit task center template':'Task Center Vorlage ändern',
   'Label is required': 'Label wird benötigt',
   'Label types': 'Typ',
   'Label type is required': 'Typ wird benötigt ',
   'Add custom label': 'Feld hinzufügen ',
   'Add document': 'Dokument hinzufügen ',
   'Add template': 'Vorlage hinzufügen ',
   'Edit template': 'Vorlage ändern',
   'Template is required': 'Vorlage wird benötigt ',
   'Label': 'Feld',
   'Add label': 'Feld hinzufügen ',
   'File form': 'Dokument hochladen',
   'Custom form': 'Formular ausfüllen',
   'Please fill custom form or file form completely': 'Bitte laden Sie ein Dokument hoch oder füllen Sie das Formular mit ihren Ergebnissen',
   'Field is required': 'Feld wird benötigt',
   'File is required': 'Dokument wird benötigt',
   'View Template': 'Vorlage ansehen',
   'Is External User':'Ist externer Nutzer',
   'Vouchers': 'Gutscheine',
   'Order': 'Bestellung',
   'Voucher Purchased Successfully': 'Gutschein erfolgreich bestellt',
   'Coupons': 'Codes',
   'View Coupons': 'Codes ansehen',
   'Send Coupons': 'Codes verschicken',
   'Sent To': 'senden',
   'Redeemed': 'eingelöst',
   'Revoke': 'zurückziehen',
   'Vouchers Available to Send': 'verfügbare Gutscheine',
   'UsersAdd': 'Nutzerauswahl',
   'Emails': 'Emailauswahl',
   'GroupsAdd': 'Gruppenauswahl',
   
   'Buy Vouchers' : 'Gutscheine kaufen',
   'Manage Vouchers' : 'Gutscheine verwalten',
   'User Groups' : 'Nutzergruppen',
   'Email Ids' : 'Email',
   
   'unused' : 'noch nicht eingelöst',
   'used' : 'eingelöst',
   'revoked': 'zurückgezogen',
   'Are you sure want to Revoke the Coupon?' : 'Sind Sie sicher, dass Sie den Gutschein zurückziehen wollen ?',
   
   'Order Purchase Confirmation' : 'Bestellbestätigung',
   'Order Summary' : 'Bestellung',
   'Subtotal' : 'Summe',
   'Coupon Code' : 'Gutscheincode',
   'Total' : 'Summe',
   'Apply' : 'anwenden',
   'I agree' : 'I habe die Nutzungsbedingungen gelesen und akzeptiere diese',
   'terms' : '[Nutzungsbedingungen]',
   'Pay securely using' : 'Sicher zahlen mit',
   'Send To':  'Senden an',
   'Need to change payment method?':  'Zahlungsmethoden ändern',
   'Thank you for Subscribing' : 'Vielen Dank für den Kauf',
   'You can find subscribed courses in your Dashboard' : 'Sie finden Ihre Kurse auf dem Dashboard',
   'Go to Dashboard':  'zum Dashboard',
   'Coupon Code Sent Successfully!': 'Gutschein erfolgreich gesendet!',
   'Some Problem occurred!': 'Es ist ein Fehler aufgetreten.',
   'Invalid Coupon Code':'Ungültiger Coupon',
   'Coupon applied Successfully':'Coupon ERFOLGREICH angewendet',
   'Limit reached':'Limit erreicht',
   'Number of Vouchers': 'Anzahl Gutscheine',
   'Buy Course Vouchers': 'Kurs-Gutscheine kaufen',
   'Manage Course Vouchers': 'Kurs-Gutscheine verwalten',
   'Buy Tutor Vouchers': 'Tutor-Gutscheine kaufen',
   'Manage Tutor Vouchers': 'Tutor-Gutscheine verwalten',
   'Book a Tutor': 'Tutor buchen',
   'No Tutor Products to display': 'Keine Tutor-Produkte verfügbar',
   'Tutor Products Available': 'Tutor-Produkte verfügbar',
   'Book': 'Buchen',
   'Pick another': 'Etwas anderes auswählen',
   'Booking Complete': 'Buchung erfolgreich',
   'Please check you email for further details.': 'Bitte überprüfen Sie ihre E-Mail Inbox für weitere Details',
   'Book Again' : 'Noch einmal buchen',
   'No User Groups assigned to this Course': 'Diesem Kurs sind keine Benutzergruppen zugewiesen',
   'Login with Office' : 'Melden Sie sich mit Office an',
   'Oops there was an error.' : 'Hoppla, es ist ein Fehler aufgetreten.',
   'Please contact Administrator.' : 'Bitte wenden Sie sich an den Administrator.',
   'Redirecting...' : 'Umleitung...',
};
